import { useContext } from 'react';
import { SourContext } from './sour-context';
export const useSourContext = () => {
    const { isLoading, setIsLoading, setShowAlert, setShowToast, openConfirmationDialog, application, godModeActive, isDesktop } = useContext(SourContext);
    const useConfirmationDialog = () => {
        const getConfirmation = ({ ...options }) => new Promise((res) => {
            openConfirmationDialog({ actionCallback: res, ...options });
        });
        return { getConfirmation };
    };
    return { isLoading, setIsLoading, setShowAlert, setShowToast, useConfirmationDialog, application, godModeActive, isDesktop };
};
//# sourceMappingURL=use-sour-context.js.map